/**
 * Utility function to safely render any data as a string for React components.
 * Prevents "Objects are not valid as a React child" errors by converting
 * objects to JSON strings.
 */
export const safeRenderData = (data: any): string => {
  if (typeof data === 'string') {
    return data;
  }
  if (typeof data === 'number' || typeof data === 'boolean') {
    return String(data);
  }
  if (data === null || data === undefined) {
    return '';
  }
  // For objects, arrays, etc., serialize them
  try {
    return JSON.stringify(data, null, 2);
  } catch {
    return '[Invalid data - cannot serialize]';
  }
};

/**
 * Safe render for arrays of mixed data types
 */
export const safeRenderArray = (arr: any[]): string[] => {
  return arr.map((item) => safeRenderData(item));
};

/**
 * Component helper to render objects in a formatted way
 */
export const renderObjectDetails = (obj: any, title: string = 'Details') => {
  if (!obj || Object.keys(obj).length === 0) {
    return null;
  }

  return {
    title,
    content: JSON.stringify(obj, null, 2)
  };
};
